import { StudentNoteCategory } from './student-note-category.model';

export class StudentNote {

    // Static Properties
	static junkDate = new Date('Wed Dec 31 1969 19:00:00 GMT-0500 (Eastern Standard Time)');
	static junkDateString = 'Wed Dec 31 1969 19:00:00 GMT-0500 (Eastern Standard Time)';

    // Server Properties
    AddedBy: string;
    AddedOn: string;
    ClassroomNote: boolean;
    DelStatus: boolean;
    DisplayBold = false;
    DisplayInStudentProfile = true;
    DisplayInTile = false;
    EndDate = new Date(StudentNote.junkDateString);
    FirstName: string;
    Id = -1;
    LastName: string;
    LastUpBy?: string;
    LastUpOn?: string;
    MiddleName: string;
    Nickname?: string;
    Note: string;
    Order: number;
    SNCID: number;
    StartDate = new Date(StudentNote.junkDateString);
    Status = 'Active';
    StudentID: number;
    StudentNumber: string;

    // Local Properties
    private _category: StudentNoteCategory;

    // Class Functions
	// NOTE: these are used for sorting. Do not delete.
    get displayBoldString(): string {
        if (this.DisplayBold) {
            return 'Y';
        } else {
            return '';
        }
    }

    get classroomNoteString(): string {
    	if (this.ClassroomNote) {
    		return 'Y';
		} else {
    		return '';
		}
	}

    // Methods
    category(categories: StudentNoteCategory[]): StudentNoteCategory {
    	// PRE: a list of  categories
		// POST: returns the category of this student note
        if (categories && (!this._category || this._category.Id != this.SNCID)) {
            this._category = categories.find(category => category.Id == this.SNCID);
        }
        return this._category;
    }

    clearJunkDates() {
    	// POST: clears the junk dates out from the note
        if (this.StartDate && this.StartDate.toString() == StudentNote.junkDate.toString()) {
            this.StartDate = null;
        }
        if (this.EndDate && this.EndDate.toString() == StudentNote.junkDate.toString()) {
            this.EndDate = null;
        }
    }
}